// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
  background-color: #fbfbfb;
  border-radius: 1rem 1rem 1rem 0;
  margin: 0 1rem;
  padding: 6px 12px;
  width: 56px;
  height: 32px;
  animation: unfold 250ms forwards ease-in-out;
}
@media all and (min-width: 1280px) {
  .loader {
    margin: 0 1.5rem;
  }
}
.loader__circles {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  grid-gap: 4px;
  height: 20px;
}
.loader__circle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 8px;
  height: 8px;
}
.loader__round {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  transition: 250ms;
  background-color: rgba(31, 72, 177, 0.5019607843);
}
.loader__round--first {
  animation: dot-flashing 0.5s infinite linear alternate;
}
.loader__round--second {
  animation: dot-flashing 0.5s 333ms infinite linear alternate;
}
.loader__round--third {
  animation: dot-flashing 0.5s 666ms infinite linear alternate;
}
@keyframes dot-flashing {
  0% {
    width: 6px;
    height: 6px;
  }
  100% {
    width: 8px;
    height: 8px;
    background-color: #1f48b1;
  }
}
@keyframes unfold {
  100% {
    width: 56px;
    height: 32px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Loader/Loader.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,yBC8BU;ED7BV,+BAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,4CAAA;AADF;AAGE;EATF;IAUI,gBAAA;EAAF;AACF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AAAJ;AAGE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;AADJ;AAIE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,iDC3Be;ADyBnB;AAII;EACE,sDAAA;AAFN;AAKI;EACE,4DAAA;AAHN;AAMI;EACE,4DAAA;AAJN;AAQE;EACE;IACE,UAAA;IACA,WAAA;EANJ;EAQE;IACE,UAAA;IACA,WAAA;IACA,yBCnDc;ED6ClB;AACF;AASE;EACE;IACE,WAAA;IACA,YAAA;EAPJ;AACF","sourcesContent":["@import 'src/styles/variables';\n\n.loader {\n  background-color: $white-100;\n  border-radius: 1rem 1rem 1rem 0;\n  margin: 0 1rem;\n  padding: 6px 12px;\n  width: 56px;\n  height: 32px;\n  animation: unfold 250ms forwards ease-in-out;\n\n  @media all and (min-width: $desktop) {\n    margin: 0 1.5rem;\n  }\n\n  &__circles {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    grid-gap: 4px;\n    height: 20px;\n  }\n\n  &__circle {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 8px;\n    height: 8px;\n  }\n\n  &__round {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    transition: 250ms;\n    background-color: $main-mid-blue-50;\n\n    &--first {\n      animation: dot-flashing 0.5s infinite linear alternate;\n    }\n\n    &--second {\n      animation: dot-flashing 0.5s 333ms infinite linear alternate;\n    }\n\n    &--third {\n      animation: dot-flashing 0.5s 666ms infinite linear alternate;\n    }\n  }\n\n  @keyframes dot-flashing {\n    0% {\n      width: 6px;\n      height: 6px;\n    }\n    100% {\n      width: 8px;\n      height: 8px;\n      background-color: $main-mid-blue-100;\n    }\n  }\n\n  @keyframes unfold {\n    100% {\n      width: 56px;\n      height: 32px;\n    }\n  }\n}","$headerHeightMobile: 60px;\n$headerHeightDesktop: 80px;\n\n$desktop: 1280px;\n\n\n// accents\n$main-blue-gradient: #100;\n$main-dark-blue: #1F106D;\n$main-mid-blue-100: #1F48B1FF;\n$main-mid-blue-50: #1F48B180;\n$main-light-blue: #A1C7FF;\n$hover-main-blue: #331CAA;\n$pressed-main-blue: #011C5A;\n$progress-bar-red: #D62B1F;\n$progress-dot-disabled: #D9D9D9;\n\n// brands\n$alfa-bank: #EF3124;\n$vsk: #4544EE;\n$h: #2078FE;\n$vtb: #002882;\n$robo-finance: #00BF6E;\n$x-5: #5FAF2D;\n$sport-master: #1551E5;\n\n// black\n$black-100: #151515FF;\n$black-75: #151515BF;\n$black-50: #15151580;\n$black-25: #15151540;\n\n// white\n$white-100: #FBFBFBFF;\n$white-75: #FBFBFBBF;\n$white-50: #FBFBFB80;\n$white-25: #FBFBFB40;\n\n// input\n$input-background: #F1F5F9;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
